import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex gap-y-6 flex-col" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "py-1 mr-2" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pt-2 pb-4 mr-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.detailData.name,
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    errorType: _ctx.apiDetailData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: "ID Banner",
          value: _ctx.detailData.id
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: "Banner Name",
          value: _ctx.detailData.name
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: "Tanggal Mulai",
          value: _ctx.detailData.formatStartDate
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: "Tanggal Berakhir",
          value: _ctx.detailData.formatEndDate
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: "Tambah URL",
          value: _ctx.detailData.url
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2",
          label: "Priority",
          value: _ctx.detailData.priority
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-1/2 capitalize",
          label: "Target Terpilih",
          value: _ctx.roleTarget
        }, null, 8, ["value"]),
        (_ctx.detailData.image)
          ? (_openBlock(), _createBlock(_component_Title, {
              key: 0,
              label: "Banner",
              fontSize: 14
            }))
          : _createCommentVNode("", true),
        (_ctx.detailData.image)
          ? (_openBlock(), _createBlock("img", {
              key: 1,
              src: _ctx.detailData.image,
              class: "w-7/12",
              alt: "banner-config-image"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_2
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            label: _ctx.detailData.status
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Dibuat",
        value: _ctx.detailData.formatCreatedAt,
        caption: _ctx.detailData.createdBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Diubah",
        value: _ctx.detailData.formatUpdatedAt,
        caption: _ctx.detailData.updatedBy
      }, null, 8, ["value", "caption"]),
      _withDirectives(_createVNode(_component_LpButton, {
        title: "Ubah",
        customClass: "w-1/2",
        onClick: _ctx.goToEdit,
        outline: "",
        textColor: "red-lp-100"
      }, null, 8, ["onClick"]), [
        [_vShow, _ctx.isEditAble]
      ]),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}